import React, { useState } from "react";
import { machineryUnits } from "../mock";
import { Settings, Gauge } from "lucide-react";
import useReveal from "../hooks/useReveal";

export default function Machinery() {
  const [active, setActive] = useState(0);
  const [ref, inView] = useReveal();
  const unit = machineryUnits[active];

  return (
    <section id="machinery" className="kse-section bg-slate-50">
      <div className="kse-container">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <span className="kse-eyebrow">
            MACHINERY & ASSETS
          </span>
          <h2 className="kse-h2">
            The Factory Running Live
          </h2>
          <p className="text-slate-500 mt-4">
            A real look at the production assets powering our Knits and Shirts units.
          </p>
        </div>

        {/* Unit toggle */}
        <div className="flex justify-center gap-3 mb-10">
          {machineryUnits.map((u, i) => (
            <button
              key={u.id}
              onClick={() => setActive(i)}
              className={`px-6 py-3 rounded-full text-sm font-semibold border transition-all ${
                active === i
                  ? "bg-[#1a2a6b] text-white border-[#1a2a6b]"
                  : "bg-white text-[#1a2a6b] border-slate-200 hover:border-[#2b3aa0]"
              }`}
            >
              {u.name}
            </button>
          ))}
        </div>

        {/* Capacity banner */}
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-3 mb-10">
          <div className="flex items-center gap-2 text-[#1a2a6b] font-semibold">
            <Gauge className="text-[#2b3aa0]" size={20} /> Capacity: {unit.capacity}
          </div>
          <div className="flex items-center gap-2 text-[#1a2a6b] font-semibold">
            <Settings className="text-[#2b3aa0]" size={20} /> {unit.seats}
          </div>
        </div>

        {/* Large asset gallery */}
        <div ref={ref} className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {unit.gallery.map((g, i) => (
            <div
              key={g.caption + i}
              className={`group relative rounded-3xl overflow-hidden h-64 shadow-sm hover:shadow-2xl transition-all reveal ${inView ? "in-view" : ""}`}
              style={{ animationDelay: `${i * 0.1}s` }}
            >
              <img src={g.image} alt={g.caption} className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#111c4e]/95 via-[#111c4e]/20 to-transparent" />
              <div className="absolute top-4 right-4 bg-white text-[#1a2a6b] font-extrabold text-lg w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg">
                {g.count}
              </div>
              <div className="absolute bottom-0 left-0 p-5">
                <h3 className="text-white font-bold text-lg leading-tight">{g.caption}</h3>
              </div>
            </div>
          ))}
        </div>

        {/* Full spec chips */}
        <div className="mt-8 bg-white rounded-3xl p-6 shadow-sm">
          <h4 className="text-[#1a2a6b] font-bold mb-4">{unit.name} &mdash; Full Machine List</h4>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
            {unit.specs.map((s) => (
              <div key={s.name} className="bg-slate-50 rounded-2xl p-4 text-center">
                <div className="text-2xl font-extrabold text-[#1a2a6b]">{s.count}</div>
                <div className="text-slate-500 text-xs mt-1 leading-tight">{s.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
